import { useCallback, useEffect, useState } from "react";
import { _AdquisitionItem, _AdquisitionPlan, _single } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { SelectAdquisitionPlan } from "../../contract/select/SelectAdquisitionPlan";
import { BasicMultiSelectTable } from "../../theme/Component/BasicMultiSelecTable";
import { MASK_MONEY, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { Alert } from "../../theme/Component/Alert";
import { YearSelector } from "../../../core/shared/inputs/YearSelector";
import { PrintJson } from "../../theme/Component/PrintJson";

interface props {
    budgetLine: any;
    listAdquisitionItem: any;
    updateAdquisitionItemList: any;
}
export const BudgetDisaggregation = ({ budgetLine, listAdquisitionItem, updateAdquisitionItemList }: props) => {

    const { instance } = useDataBean(_AdquisitionItem);
    const [bean, setBean] = useState<any>({});

    const [items, setItems] = useState<any>([]);

    const [listaResult, setListaResult] = useState<any>([]);
    const [year, setYear] = useState<number>(_single.getCurrenYear());


    useEffect(() => {
        
        
        if (bean.IDPlan > 0) {
            instance.getAdquisitionItemsByPlanAndBudgetCode(bean.IDPlan, budgetLine.BudgetIDStr).then(
                (resp: any) => {
                    
                    let ids = listAdquisitionItem.map(e=>e.DataBeanProperties.IDAdquisitionItem);
                    
                    
                    setItems(resp);
                    if (resp && ids.length>0) {
                        let temp = [];
                        resp.forEach(element => {
                            if(ids.includes(element.DataBeanProperties.IDAdquisitionItem)){
                                temp.push({
                                    DataBeanProperties: {
                                        IDAdquisitionItem: element.DataBeanProperties.IDAdquisitionItem,
                                        EstimatedValue: element.DataBeanProperties.EstimatedValue,
                                        JsonCode: element.DataBeanProperties.JsonCode,
                                    },
                                     DataBeanName: "com.orange.bean.supplier.AdquisitionItem"
                                })                                
                            }
                        });
                        setListaResult(temp);
                    }
                }
            )

        }

    }, [bean.IDPlan])

    const updateList = useCallback((list: any) => {
        if (list) {
            let items = [];
            console.log(list);
            
            // list.forEach(element => {
            //     items.push(
            //         {
            //             DataBeanProperties: {
            //                 IDAdquisitionItem: element.DataBeanProperties.IDAdquisitionItem,
            //                 StructuredValue: element.DataBeanProperties.EstimatedValue,
            //             },
            //             DataBeanName: "com.orange.bean.supplier.AdquisitionItem"
            //         }
            //     )

            // });
            
            
            setListaResult(list);
        }
    }, [])

    useEffect(()=>{
        if(listaResult && listaResult.length>0){
            let temp = listaResult.map((e:any)=>{
                return {
                    DataBeanProperties: {
                        IDAdquisitionItem: e.DataBeanProperties.IDAdquisitionItem,
                        StructuredValue: e.DataBeanProperties.EstimatedValue
                    },
                    DataBeanName: "com.orange.bean.supplier.AdquisitionItem"
    
                }
            });
            updateAdquisitionItemList(temp);
        }
        
    }, [listaResult])

    const head = [
        { title: 'ID', property: 'IDAdquisitionItem', visible: true, mask: MASK_NUMBER },
        { title: 'Valor', property: 'EstimatedValue', visible: true, mask: MASK_MONEY },
        { title: 'Objecto', property: 'Description', visible: true },
        { title: 'Estado', property: 'PreparationStateName', visible: true }
    ]


    return (
        <div className="row">

            <div className="col-md-12">
                <h6>Desagregación</h6>
            </div>
            <div className="col-md-2">
                <YearSelector tittle="Vigencia" value={year} onChange={(e) => { setYear(e) }} />
            </div>
            <div className="col-md-4">
                <SelectAdquisitionPlan idSelector={0} _year={year} onChange={(e) => { setBean({ ...bean, "IDPlan": parseInt(e) }) }} />
            </div>

            <div className="col-md-12 mt-4">
                {items.length > 0 ?
                    <BasicMultiSelectTable body={items} bodyResult={listaResult} head={head} keyId="IDAdquisitionItem" updateValues={({ bodyResult }) => { updateList(bodyResult) }}></BasicMultiSelectTable>
                    :
                    <Alert clase="primary">
                        <p>No hay necesidades asociadas al rubro</p>
                    </Alert>
                }
                {/* <PrintJson json={listaResult} /> */}
            </div>

        </div>
    )
}